import React, { Component } from "react";
import { Card, Row, Col, Table, Button, Alert, Badge } from "react-bootstrap";
import { FaKey, FaSync, FaBan } from "react-icons/fa";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import api from "../../services/api";
import { getCurrentUser } from "../../common/utils";

class ApiKeysPrograma extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            erro: "",
            grupos: [],
            processandoGrupoId: null,
            dadosUsuario: getCurrentUser() || {},
        };
    }

    componentDidMount() {
        this.carregarGruposApiKey();
    }

    carregarGruposApiKey = () => {
        this.setState({ loading: true, erro: "" });

        api.get(`/integracao/external-api-keys/?programa_id=${this.props.programa_id}`)
            .then((response) => {
                this.setState({
                    grupos: response.data || [],
                    loading: false,
                    erro: "",
                });
            })
            .catch((error) => {
                let erro_msg = "Erro ao carregar API Keys por grupo.";
                if (error.response && error.response.status === 403) {
                    erro_msg = "Você não tem permissão para visualizar API Keys deste programa.";
                } else if (error.response && error.response.status === 500) {
                    erro_msg = "Servidor indisponível no momento.";
                }
                this.setState({ erro: erro_msg, loading: false });
            });
    };

    gerarApiKey = (item, regenerar = false) => {
        const MySwal = withReactContent(Swal);
        const acao = regenerar ? "regenerar" : "criar";

        MySwal.fire({
            title: regenerar ? "Regenerar API Key?" : "Criar API Key?",
            text: `Deseja ${acao} a chave para o grupo \"${item.grupo_nome}\"?`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: regenerar ? "Sim, regenerar" : "Sim, criar",
            cancelButtonText: "Cancelar",
        }).then((result) => {
            if (!result.isConfirmed) {
                return;
            }

            this.setState({ processandoGrupoId: item.grupo_id });

            api.post("/integracao/external-api-keys/", {
                programa_id: this.props.programa_id,
                grupo_id: item.grupo_id,
                regenerar,
            })
                .then((response) => {
                    const key = response?.data?.key || "";

                    MySwal.fire({
                        title: <p>API Key gerada com sucesso</p>,
                        html: `
                            <div style="word-break:break-all; margin-bottom: 12px;">
                                <strong>Chave:</strong><br/>${key}
                            </div>
                            <button id="copy-api-key-btn" class="swal2-confirm swal2-styled" style="margin: 0;">Copiar chave</button>
                            <div id="copy-api-key-feedback" style="margin-top: 8px; font-size: 12px; color: #666;"></div>
                        `,
                        icon: "success",
                        showCloseButton: true,
                        showConfirmButton: false,
                        didOpen: () => {
                            const copyBtn = document.getElementById("copy-api-key-btn");
                            const feedback = document.getElementById("copy-api-key-feedback");

                            const showFeedback = (msg, ok = true) => {
                                if (!feedback) {
                                    return;
                                }
                                feedback.textContent = msg;
                                feedback.style.color = ok ? "#1b8a3d" : "#b42318";
                            };

                            const copyText = async () => {
                                try {
                                    if (navigator.clipboard && navigator.clipboard.writeText) {
                                        await navigator.clipboard.writeText(key);
                                    } else {
                                        const textArea = document.createElement("textarea");
                                        textArea.value = key;
                                        textArea.style.position = "fixed";
                                        textArea.style.opacity = "0";
                                        document.body.appendChild(textArea);
                                        textArea.focus();
                                        textArea.select();
                                        document.execCommand("copy");
                                        document.body.removeChild(textArea);
                                    }
                                    showFeedback("Chave copiada para a area de transferencia.");
                                } catch (e) {
                                    showFeedback("Nao foi possivel copiar automaticamente.", false);
                                }
                            };

                            if (copyBtn) {
                                copyBtn.addEventListener("click", copyText);
                            }
                        },
                    });

                    this.setState({ processandoGrupoId: null });
                    this.carregarGruposApiKey();
                })
                .catch((error) => {
                    let erro_msg = "Erro ao gerar API Key.";
                    if (error.response && error.response.status === 403) {
                        erro_msg = "Somente superusuário pode criar/regenerar API Key.";
                    } else if (error.response && error.response.status === 400) {
                        erro_msg = "Dados inválidos para criação da API Key.";
                    } else if (error.response && error.response.status === 500) {
                        erro_msg = "Servidor indisponível no momento.";
                    }

                    MySwal.fire({
                        title: <p>{erro_msg}</p>,
                        icon: "error",
                        showCloseButton: true,
                    });

                    this.setState({ processandoGrupoId: null });
                });
        });
    };

    revogarApiKey = (item) => {
        const MySwal = withReactContent(Swal);

        MySwal.fire({
            title: "Revogar API Key?",
            text: `Deseja revogar a chave do grupo \"${item.grupo_nome}\"?`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Sim, revogar",
            cancelButtonText: "Cancelar",
        }).then((result) => {
            if (!result.isConfirmed) {
                return;
            }

            this.setState({ processandoGrupoId: item.grupo_id });

            api.delete(`/integracao/external-api-keys/${item.api_key_id}/`)
                .then(() => {
                    MySwal.fire({
                        title: <p>API Key revogada com sucesso</p>,
                        icon: "success",
                        showCloseButton: true,
                    });

                    this.setState({ processandoGrupoId: null });
                    this.carregarGruposApiKey();
                })
                .catch((error) => {
                    let erro_msg = "Erro ao revogar API Key.";
                    if (error.response && error.response.status === 403) {
                        erro_msg = "Somente superusuário pode revogar API Key.";
                    } else if (error.response && error.response.status === 500) {
                        erro_msg = "Servidor indisponível no momento.";
                    }

                    MySwal.fire({
                        title: <p>{erro_msg}</p>,
                        icon: "error",
                        showCloseButton: true,
                    });

                    this.setState({ processandoGrupoId: null });
                });
        });
    };

    renderRows = () => {
        const isSuperuser = !!(this.state.dadosUsuario?.is_superuser || this.state.dadosUsuario?.tipo_usuario === "");

        if (!this.state.grupos.length) {
            return (
                <tr>
                    <td colSpan={6}>Nenhum grupo encontrado.</td>
                </tr>
            );
        }

        return this.state.grupos.map((item) => (
            <tr key={item.grupo_id}>
                <td>{item.grupo_nome}</td>
                <td>
                    {item.tem_chave ? (
                        <Badge bg={item.ativo ? "success" : "secondary"}>
                            {item.ativo ? "Com chave" : "Inativa"}
                        </Badge>
                    ) : (
                        <Badge bg="warning" text="dark">Sem chave</Badge>
                    )}
                </td>
                <td>{item.chave_mascarada || "-"}</td>
                <td style={{ maxWidth: 380 }}>
                    <small>{(item.permissoes || []).join(", ") || "Sem permissões"}</small>
                </td>
                <td>{item.data_atualizacao ? new Date(item.data_atualizacao).toLocaleString("pt-BR") : "-"}</td>
                <td>
                    {!item.tem_chave && (
                        <Button
                            variant="outline-primary"
                            size="sm"
                            disabled={!isSuperuser || this.state.processandoGrupoId === item.grupo_id}
                            onClick={() => this.gerarApiKey(item, false)}
                        >
                            <FaKey /> Criar
                        </Button>
                    )}

                    {item.tem_chave && (
                        <>
                            <Button
                                variant="outline-secondary"
                                size="sm"
                                disabled={!isSuperuser || this.state.processandoGrupoId === item.grupo_id}
                                onClick={() => this.gerarApiKey(item, true)}
                                className="me-2"
                            >
                                <FaSync /> Regenerar
                            </Button>
                            {item.ativo && (
                                <Button
                                    variant="outline-danger"
                                    size="sm"
                                    disabled={!isSuperuser || this.state.processandoGrupoId === item.grupo_id}
                                    onClick={() => this.revogarApiKey(item)}
                                >
                                    <FaBan /> Revogar
                                </Button>
                            )}
                        </>
                    )}
                </td>
            </tr>
        ));
    };

    render() {
        const isSuperuser = !!(this.state.dadosUsuario?.is_superuser || this.state.dadosUsuario?.tipo_usuario === "");

        return (
            <Card className="cardDestaque">
                <Card.Body>
                    <Row className="mb-3">
                        <Col sm={8}>
                            <h5>API Keys por Grupo</h5>
                            <small>
                                Cada programa possui no máximo uma API Key por grupo. O escopo de acesso é definido pelas permissões do grupo.
                            </small>
                        </Col>
                        <Col sm={4} className="text-end">
                            <Button variant="outline-secondary" size="sm" onClick={this.carregarGruposApiKey}>
                                <FaSync /> Atualizar
                            </Button>
                        </Col>
                    </Row>

                    {!isSuperuser && (
                        <Alert variant="warning">
                            Somente superusuário pode criar ou regenerar API Keys.
                        </Alert>
                    )}

                    {this.state.erro && (
                        <Alert variant="danger">{this.state.erro}</Alert>
                    )}

                    <Table responsive className="custom-table">
                        <thead>
                            <tr>
                                <th>Grupo</th>
                                <th>Status</th>
                                <th>Chave</th>
                                <th>Permissões do Grupo</th>
                                <th>Atualização</th>
                                <th>Ações</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.state.loading ? (
                                <tr>
                                    <td colSpan={6}>Carregando...</td>
                                </tr>
                            ) : (
                                this.renderRows()
                            )}
                        </tbody>
                    </Table>
                </Card.Body>
            </Card>
        );
    }
}

export default ApiKeysPrograma;
